import { useEffect } from "react";
import { detectBarcodeFormat } from "../pages/hdi-scanner-page/hdiScannerPageUtils";
import { SymbologyType } from "../types/SymbologyType";

export default function useCoworkerHubScanner(
  handleScanEvent: (
    scannedBarcode: string,
    symbologyFormat: SymbologyType
  ) => void
) {
  useEffect(() => {
    const handleScanMessage = (event: MessageEvent) => {
      if (event?.origin !== window.location.origin) return;

      const input = event.data || "";
      const code =
        input?.split && input.split("honeywellbarcode://")[1]?.trim();
      if (!code) return;

      const symbologyFormat = detectBarcodeFormat(code);
      handleScanEvent(code, symbologyFormat);
    };
    window.addEventListener("message", handleScanMessage, false);
    return () =>
      window.removeEventListener("message", handleScanMessage, false);
  }, [handleScanEvent]);
}
